export default String.raw`
.customer-container {
    display: block;
}

.side-menu {
    display: none;
}

.customer-submenu {
    margin: 0 !important;
}

.toggle-waybill-details {
    .waybill-details {
        @media screen and (max-width: 1069px) {
            &__row {
                grid-template-columns: repeat(2, minmax(150px, 1fr));
            }
        }
    }
}

.order-details {
    @media screen and (max-width: 1069px) {
        &__row {
            grid-template-columns: repeat(2, minmax(150px, 1fr));
        }
    }
}

.options,
.dropdown-wrapper {
    @media screen and (max-width: 885px) {
        .dropdown.details {
            right: auto;
            left: 0;
        }
    }
}

@media screen and (max-width: 999px) {
    .order {
      flex-direction: column;
    }
}
`